// src/pages/Items.tsx
import React, { useEffect, useState } from 'react';
import { IonContent, IonPage } from '@ionic/react';
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Button,
} from '@mui/material';
import { StockItem } from '../../../models/stocks';
import { getBarInventory ,getStewardInventory} from '../../../api/products/product';
import { formatCurrencyN } from '../../../common/utils_t';
// import { StockItem } from '../models/Stock';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateRange } from '@mui/icons-material';

const StewardItems: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [stockItems, setStockItems] = useState<StockItem[]>([]);
    const [dateRange, setDateRange] = useState<{
      start: Date | null;
      end: Date | null;
    }>({ start: null, end: null });


  const fetchStocks = async () => {
    try {
      const response = await getStewardInventory()
      console.log({response})
      setStockItems(response.data)
    } catch (error) {
      console.error(error)
    }
  }



  useEffect(() => {
    fetchStocks()
  }, [])


const filteredItems = stockItems.filter(item =>
  (item.name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
  (item.category_name || "").toLowerCase().includes(searchTerm.toLowerCase())
  // || (item.location || "").toLowerCase().includes(searchTerm.toLowerCase())
);


  return (
    <IonPage className="pushDown" >
      <IonContent>
        <Box sx={{ p: 3 }}>
          <Typography variant="h4" gutterBottom>
            Stock Items
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
            <TextField
              label="Search Items"
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            
              <DatePicker
                          label="Start Date"
                          value={dateRange.start}
                          onChange={(newValue) =>
                            setDateRange((prev) => ({ ...prev, start: newValue }))
                          }
                          renderInput={(params) => <TextField {...params} size="small" />}
                          components={{
                            OpenPickerIcon: DateRange,
                          }}
                        />
          
                        <DatePicker
                          label="End Date"
                          value={dateRange.end}
                          onChange={(newValue) =>
                            setDateRange((prev) => ({ ...prev, end: newValue }))
                          }
                          renderInput={(params) => <TextField {...params} size="small" />}
                          components={{
                            OpenPickerIcon: DateRange,
                          }}
                          minDate={dateRange.start}
                        />

                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            // Handle date range filter logic here
                            console.log('Selected date range:', dateRange);
                          }}
                          sx={{ ml: 2 }}
                        >
                          Filter
                        </Button>
          </Box>




          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Quantity</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Min Stock</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredItems.map((item) => (
                  <TableRow key={item.product_id}>
                    <TableCell>{item.name}</TableCell>
                    <TableCell> {formatCurrencyN(item.price)}</TableCell>
                    <TableCell>
                      {item.qty} 
                    </TableCell>
                    <TableCell>{item.category_name}</TableCell>
                    <TableCell>
                      <span style={{ color: item.qty < 10 ? 'red' : 'inherit' }}>
                     { item.qty < 10 ? 'Low' : 'Available'}
                      </span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </IonContent>
    </IonPage>
  );
};

export default StewardItems;